import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SessionService } from '../services/session/session.service';
import { environment } from '../../environments/environment';

export const apiInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.heimdallUrl))
    return next(req);

  if (req.headers.has('Authorization'))
    return next(req);

  const session = inject(SessionService);
  const token = session.token();
  if (!token)
    return next(req);

  const schoolId = session.user()?.schoolId;
  return next(
    req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        ...(schoolId && { 'x-school-id': schoolId }),
      },
    }),
  );
};
